import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { LeadFormProps, LeadFormStepFields } from "@/component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@/component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { FormRadio, ProgressButton } from "@/shared/ui";
import { REQUEST_CONSULTANT_CALL_OPTIONS } from "../data";
import { isConsultantUsedCalculator } from "../domain";

interface Props extends LeadFormProps {
	consultant?: string;
	source?: string;
}

export interface StepFields extends LeadFormStepFields {
	lastName: string;
	firstName: string;
	email: string;
	phone: string;
	cityName: string;
	cityId?: number;
	requestConsultantCall: boolean;
}

export class LeadForm extends BasicLeadForm<StepFields, Props> {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: <>A részletes eredményedet e-mailben fogjuk elküldeni!</>,
	};

	protected initValues(): StepFields {
		const { consultant, source } = this.props;

		return {
			lastName: undefined,
			firstName: undefined,
			cityName: undefined,
			phone: undefined,
			email: undefined,
			cityId: undefined,
			requestConsultantCall: isConsultantUsedCalculator(consultant, source) ? true : undefined,
		};
	}

	protected renderContent(_values: StepFields, _form: FormApi<StepFields, Partial<StepFields>>): ReactNode {
		const { consultant, source } = this.props;

		return (
			<>
				{this.renderHeader()}
				<Card.Body className="bg-white text-dark">
					{super.renderFields()}
					{!isConsultantUsedCalculator(consultant, source) && (
						<FormRadio
							label=""
							name="requestConsultantCall"
							options={REQUEST_CONSULTANT_CALL_OPTIONS}
							variant="button"
							required
							boldFirstOption
							className="text-dark border rounded m-0 mb-1"
						/>
					)}
					{super.renderCheckboxes()}
				</Card.Body>
				<Card.Footer className="text-center bg-white">
					<div className="text-dark mb-2">{super.renderPrivacyStatement()}</div>
					<ProgressButton
						type="submit"
						variant="primary"
						className="font-weight-bold"
						block
						disabled={super.isDisabled()}
					>
						Elküldöm
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected renderHeader(): ReactNode {
		const { title } = this.props;

		if (!title) {
			return null;
		}

		return (
			<Card.Header className="bg-primary rounded-top">
				<div className="h4 mb-0 text-center">{title}</div>
			</Card.Header>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
